/**
 * @generated SignedSource<<c9c94e17c02a6ec02164842208e09b30>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
export type SearchLinkedResultCategory = "child" | "mentionedBy" | "mentions" | "similar" | "%future added value";
export type SearchResultType = "ask" | "attachment" | "blogpost" | "board" | "comment" | "component" | "dashboard" | "database" | "document" | "embed" | "filter" | "focus_area" | "focus_area_status_update" | "folder" | "goal" | "goal_update" | "issue" | "learning" | "message" | "object" | "page" | "plan" | "position" | "presentation" | "project" | "project_update" | "question" | "repository" | "schema" | "slide" | "space" | "spreadsheet" | "tag" | "type" | "unrecognised" | "video" | "whiteboard" | "%future added value";
import type { FragmentRefs } from "relay-runtime";
export type searchGraphDocument_AtlassianSearchPage$data = {
  readonly __typename: "SearchResultGraphDocument";
  readonly entity: {
    readonly container?: {
      readonly displayName?: string | null | undefined;
      readonly url?: string | null | undefined;
    } | null | undefined;
    readonly nonIndexableContent?: {
      readonly mediaThumbnailUrl: string | null | undefined;
    } | null | undefined;
    readonly parent?: {
      readonly displayName?: string | null | undefined;
    } | null | undefined;
    readonly thirdPartyId?: string | null | undefined;
    readonly type?: {
      readonly iconUrl: string | null | undefined;
    } | null | undefined;
  } | null | undefined;
  readonly excerpt: string | null | undefined;
  readonly id: string;
  readonly lastModifiedDate: string | null | undefined;
  readonly linkedEntities: ReadonlyArray<{
    readonly entity: {
      readonly displayName?: string | null | undefined;
    } | null | undefined;
    readonly excerpt: string | null | undefined;
    readonly id: string;
    readonly parentId: string | null | undefined;
    readonly url: string;
  }> | null | undefined;
  readonly linkedResults: ReadonlyArray<{
    readonly category: SearchLinkedResultCategory;
    readonly connectorType: string | null | undefined;
    readonly description: string;
    readonly id: string;
    readonly integrationId: string | null | undefined;
    readonly lastModifiedDate: string | null | undefined;
    readonly providerId: string | null | undefined;
    readonly subtype: string | null | undefined;
    readonly title: string;
    readonly type: SearchResultType;
    readonly url: string;
  }> | null | undefined;
  readonly permissionLevel: string | null | undefined;
  readonly title: string;
  readonly url: string;
  readonly " $fragmentType": "searchGraphDocument_AtlassianSearchPage";
};
export type searchGraphDocument_AtlassianSearchPage$key = {
  readonly " $data"?: searchGraphDocument_AtlassianSearchPage$data;
  readonly " $fragmentSpreads": FragmentRefs<"searchGraphDocument_AtlassianSearchPage">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "kind": "ScalarField",
  "name": "id"
},
v1 = {
  "kind": "ScalarField",
  "name": "title"
},
v2 = {
  "kind": "ScalarField",
  "name": "url"
},
v3 = {
  "kind": "ScalarField",
  "name": "excerpt"
},
v4 = {
  "kind": "ScalarField",
  "name": "lastModifiedDate"
},
v5 = {
  "kind": "ScalarField",
  "name": "displayName"
},
v6 = [
  (v5/*: any*/)
];
return {
  "argumentDefinitions": [
    {
      "defaultValue": true,
      "kind": "LocalArgument",
      "name": "includeThirdPartyId"
    }
  ],
  "kind": "Fragment",
  "name": "searchGraphDocument_AtlassianSearchPage",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "__typename"
    },
    (v0/*: any*/),
    (v1/*: any*/),
    (v2/*: any*/),
    (v3/*: any*/),
    (v4/*: any*/),
    {
      "kind": "ScalarField",
      "name": "permissionLevel"
    },
    {
      "kind": "LinkedField",
      "name": "entity",
      "plural": false,
      "selections": [
        {
          "kind": "InlineFragment",
          "selections": [
            {
              "condition": "includeThirdPartyId",
              "kind": "Condition",
              "passingValue": true,
              "selections": [
                {
                  "kind": "ScalarField",
                  "name": "thirdPartyId"
                }
              ]
            },
            {
              "concreteType": "ExternalDocumentType",
              "kind": "LinkedField",
              "name": "type",
              "plural": false,
              "selections": [
                {
                  "kind": "ScalarField",
                  "name": "iconUrl"
                }
              ]
            },
            {
              "concreteType": "ExternalLargeContent",
              "kind": "LinkedField",
              "name": "nonIndexableContent",
              "plural": false,
              "selections": [
                {
                  "kind": "ScalarField",
                  "name": "mediaThumbnailUrl"
                }
              ]
            },
            {
              "kind": "LinkedField",
              "name": "parent",
              "plural": false,
              "selections": [
                {
                  "kind": "InlineFragment",
                  "selections": (v6/*: any*/),
                  "type": "ExternalDocument"
                }
              ]
            },
            {
              "kind": "LinkedField",
              "name": "container",
              "plural": false,
              "selections": [
                {
                  "kind": "InlineFragment",
                  "selections": [
                    (v5/*: any*/),
                    (v2/*: any*/)
                  ],
                  "type": "ExternalSpace"
                }
              ]
            }
          ],
          "type": "ExternalDocument"
        }
      ]
    },
    {
      "concreteType": "SearchResultGraphDocument",
      "kind": "LinkedField",
      "name": "linkedEntities",
      "plural": true,
      "selections": [
        (v0/*: any*/),
        {
          "kind": "ScalarField",
          "name": "parentId"
        },
        (v3/*: any*/),
        (v2/*: any*/),
        {
          "kind": "LinkedField",
          "name": "entity",
          "plural": false,
          "selections": [
            {
              "kind": "InlineFragment",
              "selections": (v6/*: any*/),
              "type": "ExternalComment"
            }
          ]
        }
      ]
    },
    {
      "concreteType": "SearchLinkedResult",
      "kind": "LinkedField",
      "name": "linkedResults",
      "plural": true,
      "selections": [
        (v0/*: any*/),
        (v1/*: any*/),
        (v2/*: any*/),
        {
          "kind": "ScalarField",
          "name": "type"
        },
        {
          "kind": "ScalarField",
          "name": "description"
        },
        (v4/*: any*/),
        {
          "kind": "ScalarField",
          "name": "category"
        },
        {
          "kind": "ScalarField",
          "name": "subtype"
        },
        {
          "kind": "ScalarField",
          "name": "integrationId"
        },
        {
          "kind": "ScalarField",
          "name": "providerId"
        },
        {
          "kind": "ScalarField",
          "name": "connectorType"
        }
      ]
    }
  ],
  "type": "SearchResultGraphDocument"
};
})();

(node as any).hash = "e136425f34dabec4dde19ffe92b24579";

export default node;
